import { render, staticRenderFns } from "./OverallPlan.vue?vue&type=template&id=70b810d5&scoped=true&"
import script from "./OverallPlan.vue?vue&type=script&lang=js&"
export * from "./OverallPlan.vue?vue&type=script&lang=js&"
import style0 from "./OverallPlan.vue?vue&type=style&index=0&id=70b810d5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b810d5",
  null
  
)

export default component.exports